import Component from '@glimmer/component';
import GlobalFlowIcon from 'garaje/components/global-flow-icon';

interface FlowOption {
  constructor: { modelName?: string };
  isGlobal?: boolean;
  isGlobalChild?: boolean;
  [key: string]: unknown;
}

interface CopyFlowDropdownSelectedItemSignature {
  Args: {
    dropdownType?: string;
    field: string;
    option: FlowOption;
  };
}

export default class CopyFlowDropdownSelectedItem extends Component<CopyFlowDropdownSelectedItemSignature> {
  get isGlobal(): boolean {
    const { option } = this.args;
    return option.constructor.modelName === 'copy-global-flow' || !!option.isGlobal || !!option.isGlobalChild;
  }

  get displayName(): string {
    const value = this.args.option[this.args.field];
    return typeof value === 'string' ? value : '';
  }

  <template>
    <GlobalFlowIcon @show={{this.isGlobal}}>
      {{~this.displayName}}
      <span class="font-normal">{{@dropdownType}}</span>
    </GlobalFlowIcon>
  </template>
}
